import React, { useContext } from 'react'

const AppContext = React.createContext({})
export const useWeb3App = () => useContext(AppContext)
export default AppContext
